<h2 class="mt-4 mb-4">
  {{ "pageHtml" | transloco }}
</h2>
<div class="row mb-4" *ngIf="tenant">
  <app-tenant-html-form
    [tenantModel]="editTenantModel"
    (submitedValue)="update($event)"
  ></app-tenant-html-form>
</div>
